import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useDispatch, useSelector } from "react-redux";
import { fetchGallery } from "../../../features/gallerySlice/gallerySlice";
import Images from "../../../media/images";
import Photos from "./Photos";
import Videos from "./Videos";

const PhotosAndVideos = () => {
  // const [fetchImages, setFetchImages] = useState([]);
  // const [fetchVideos, setFetchVideos] = useState([]);
  const [fetchData, setFetchData] = useState([]);
  const gallery = useSelector((state) => state.gallery);
  const dispatch = useDispatch();
  // console.log("gall", gallery);
  useEffect(() => {
    dispatch(fetchGallery());
    // console.log("this is firs data");
    // console.log(gallery);
  }, []);
  const photos = [];
  const videos = [];
  useEffect(() => {
    setFetchData(gallery);
    // if (gallery.length > 0) {
    // gallery.data?.map((item) => {
    //   if (item.media_type === "IM") {
    //     setFetchImages((prev) => ({ ...prev, prev }));
    //   } else if (item.media_typmedia_typee === "VI") {
    //     setFetchVideos((prev) => ({ ...prev, item }));
    //   }
    // });
    // }
  });

  useEffect(() => {
    // console.log("here some data");
    // console.log(fetchData);
  }, [fetchData]);
  // console.log("photos", fetchImages);
  // console.log("videos", fetchVideos);

  const [isActiveLink, setIsActiveLink] = useState(0);
  const [showActive, setShowActive] = useState(0);
  const activeHandler = (index) => {
    setIsActiveLink(index);
    setShowActive(index);
  };

  return (
    <div className="">
      <Helmet>
        <title>Gallery</title>
      </Helmet>
      <div className="w-padding mt-5 w-full">
        <div className="max-w">
          <div className="text-center">
            <h1 className="title-style">Our Gallery</h1>
            <div className="mt-4">
              <img src={Images.title_border} alt="" className="mx-auto" />
            </div>
          </div>
          <div className="mt-10">
            <div className="tabs border-primary-red r m-0 flex list-none flex-wrap items-center justify-center gap-10 border-b-4 p-0">
              <div
                onClick={() => activeHandler(0)}
                className={`font-Bree cursor-pointer ${
                  isActiveLink === 0 && "bg-[#0e4ca0] text-white"
                } rounded-t-lg px-20 py-3 text-center text-2xl font-bold`}
              >
                <span>Photos</span>
              </div>
              <div
                onClick={() => activeHandler(1)}
                className={`font-Bree cursor-pointer ${
                  isActiveLink === 1 && "bg-[#0e4ca0] text-white"
                } rounded-t-lg px-20 py-3 text-center text-2xl font-bold`}
              >
                <span>Videos</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showActive === 0 && <Photos/>}
      {showActive === 1 && <Videos />}
    </div>
  );
};

export default PhotosAndVideos;
